import gql from "graphql-tag"

const GET_OMDB_ID = gql`
  query getOmdbId($id: String!, $serviceName: String!) {
    omdbId(id: $id, serviceName: $serviceName)
  }
`
export default GET_OMDB_ID
